module.exports = __webpack_public_path__ + "img/gjdw.9f7504bd.svg";